import { GetStaticPaths, GetStaticProps } from "next";
import { FunctionComponent } from "react";
import { SuperHero } from "@bluebottlecoffee/design-system";
import sanityClient from "../../../lib/sanity-client";
import renderModule from "../../../lib/render-module";
import { toSuperHeroProps } from "../../../lib/transformers/super-hero";
import { LayoutWrapper } from "../../../components/LayoutWrapper";
import {
  getDefaultStaticPaths,
  getDefaultStaticProps,
} from "../../../lib/utils";
import { InstantEspresso } from "../../../lib/sanity-schema";
import { BaseProps, filters } from "../../../lib/sanity/shared";

interface PageData extends BaseProps {
  instantEspresso: InstantEspresso;
}

export const getStaticProps: GetStaticProps<PageData> = async (context) => {
  const { props: defaultProps } = await getDefaultStaticProps(context);

  const instantEspresso = await sanityClient().fetch<InstantEspresso>(`*[
    ${filters.whereType("instantEspresso")} &&
    ${filters.excludeDrafts}
  ][0]`);

  return {
    props: {
      instantEspresso,
      ...defaultProps,
    },
  };
};

export const getStaticPaths: GetStaticPaths = getDefaultStaticPaths;

function validate(data: InstantEspresso) {
  if (!data.title) {
    throw Error("Instant Espresso page must have a title.");
  }
}

const OurStoryPage: FunctionComponent<PageData> = ({
  instantEspresso,
  ...layoutWrapperProps
}) => {
  validate(instantEspresso);
  const { region, lang } = layoutWrapperProps;

  return (
    <LayoutWrapper
      {...{
        ...layoutWrapperProps,
        pageTitle: instantEspresso.title,
        metaTags: instantEspresso.metaTags,
      }}
    >
      {instantEspresso.hero?.length > 0 && (
        <SuperHero {...toSuperHeroProps(instantEspresso.hero, region, lang)} />
      )}
      {instantEspresso.modules?.length > 0 &&
        instantEspresso.modules.map((m) => renderModule(m, region, lang))}
    </LayoutWrapper>
  );
};

export default OurStoryPage;
